const quickLinks = [
  { label: "投稿通道", href: "#channels" },
  { label: "投稿流程", href: "#process" },
  { label: "在线投稿", href: "#submit" },
];

const topicLinks = [
  { label: "热门分类", href: "#categories" },
  { label: "知情者说", href: "#tips" },
  { label: "常见问题", href: "#faq" },
];

const brandLinks = [
  { label: "关于我们", href: "#about" },
  { label: "联系我们", href: "#contact" },
  { label: "返回顶部", href: "#top" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-950">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50">
                <i className="ri-water-flash-line" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">瓜田爆料</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">
              专注匿名投稿与线索征集的中文爆料平台。写下你知道的那部分，剩下的交给编辑核实。
            </p>
            <a
              href="mailto:editor@guatianbaoliao.com"
              className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-accent-400 transition-colors hover:text-accent-300"
            >
              <i className="ri-mail-line" aria-hidden="true" />
              editor@guatianbaoliao.com
            </a>
          </div>

          <nav aria-label="投稿相关">
            <h3 className="font-heading text-sm font-bold text-background-50">投稿相关</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="内容板块">
            <h3 className="font-heading text-sm font-bold text-background-50">内容板块</h3>
            <ul className="mt-4 space-y-3">
              {topicLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="品牌与支持">
            <h3 className="font-heading text-sm font-bold text-background-50">品牌与支持</h3>
            <ul className="mt-4 space-y-3">
              {brandLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 瓜田爆料 · 匿名投稿与线索征集平台
          </p>
          <p className="text-xs leading-relaxed text-background-400">
            平台仅提供线索接收与核实协助，不对未经证实的内容作事实性结论。
          </p>
        </div>
      </div>
    </footer>
  );
}